import React, { useContext, useState } from 'react';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { IconButton, Menu } from '@mui/material';
import { CollectionOpenSearch } from '@europrocurement/l2d-domain';
import {
    OrderActionContext,
    useCollectionActionMenuItems,
    useSelectedOrderContext,
} from '@europrocurement/l2d-modules';

export type ActionMenuProps = {
    collection: CollectionOpenSearch;
};

const ActionMenu: React.FunctionComponent<ActionMenuProps> = function (props) {
    const { collection } = props;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { triggerAction } = useContext(OrderActionContext);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const { refreshOrder } = useSelectedOrderContext();
    const { collectionActionMenuItemsBack } = useCollectionActionMenuItems({
        collection,
        triggerAction,
        setAnchorEl,
        refreshCollection: refreshOrder,
    });

    return (
        <div
            onClick={(e) => {
                e.stopPropagation();
            }}
            onKeyDown={() => {}}
            role="button"
            tabIndex={0}
        >
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <FaOptionIcon
                    icon={['fasl', 'ellipsis-vertical']}
                    sx={{ fontSize: '1rem' }}
                />
            </IconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {collectionActionMenuItemsBack.map((menuItem) => menuItem)}
            </Menu>
        </div>
    );
};

export default ActionMenu;
